import React from 'react'
import {
  DotGuyImageContainer,
  OurStoryContent,
  TreesImageContainer,
  TreesWithSquareImageContainer,
  OurStoryTextContainer,
  Wrapper
} from './ourStory.styles'
import Paragraph from 'elements/typography/paragraph'
import Heading from 'src/elements/typography/heading'
import { palette } from 'src/styles/colors'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

const OurStory = (): JSX.Element => {
  const images: { [key: string]: { gatsbyImageData: IGatsbyImageData } } = useStaticQuery(graphql`{
    trees: contentfulAsset(contentful_id: {eq: "6FkC57aKwLVJ4zJsh45IpS"}) {
      gatsbyImageData(width: 500, layout: CONSTRAINED, placeholder: BLURRED)
    }
    treesWithSquare: contentfulAsset(contentful_id: {eq: "5jnklLloeg8keBxacQxeEf"}) {
      gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
    }
    dotGuy: contentfulAsset(contentful_id: {eq: "45uZEh78q7Y8jxpZTAQHKR"}) {
      gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
    }
  }
  `)

  return (
    <Wrapper>
      <OurStoryContent>
        <TreesWithSquareImageContainer>
          <GatsbyImage
            image={images.treesWithSquare.gatsbyImageData}
            alt="Trees With Square"
          />
        </TreesWithSquareImageContainer>
        <DotGuyImageContainer>
          <GatsbyImage
            image={images.dotGuy.gatsbyImageData}
            alt="Dot Guy"
          />
        </DotGuyImageContainer>
        <OurStoryTextContainer>
          <Heading
            text="Our Story"
            align="center"
            weight="normal"
            size="2.75rem"
            sizeSm="1.5rem"
            color={palette.greyText}
          />
          <Paragraph
            size="1.75rem"
            sizeSubLg="1.3rem"
            sizeSm="1.2rem"
            weight="light"
            align="center"
            color={palette.greyText}
            text="Mighty Networks was founded in 2017 by  Gina Bianchini, Tim Herby, and Thomas Aaron to drive community innovation and offer a different kind of online business more people could participate in and be proud of."
          />
          <Paragraph
            size="1.75rem"
            sizeSubLg="1.3rem"
            sizeSm="1.2rem"
            weight="light"
            align="center"
            color={palette.greyText}
            text="Prior to Mighty Networks, Gina was the CEO & Co-Founder of Ning, a pioneering social platform that flipped the script and offered creators and brands the opportunity to build their own social networks. Under her leadership, Ning grew rapidly to to serve 100M people around the world."
          />
          <Paragraph
            size="1.75rem"
            sizeSubLg="1.3rem"
            sizeSm="1.2rem"
            weight="light"
            align="center"
            color={palette.greyText}
          >
            Gina has had a front row seat to the growth of nearly 1M successful online communities and businesses and shares a proven framework for powering business through community in <a href="https://hosts.mn.co/plans/159229" target="_blank" rel="noopener noreferrer">Mighty’s Community Design ™ Accelerator</a>.
          </Paragraph>
        </OurStoryTextContainer>
        <TreesImageContainer>
          <GatsbyImage
            image={images.trees.gatsbyImageData}
            alt="Trees"
          />
        </TreesImageContainer>
      </OurStoryContent>
    </Wrapper>
  )
}

export default OurStory
